import React from 'react';
import classNames from 'classnames';

import css from './IconInfo.module.css';

/**
 * Info icon - simple ℹ️ character.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @param {string} [props.size] - Size of the icon ('small' | 'medium' | 'large')
 * @returns {JSX.Element} Info icon
 */
const IconInfo = props => {
  const { className, rootClassName, size = 'medium' } = props;
  const classes = classNames(rootClassName || css.root, className, {
    [css.small]: size === 'small',
    [css.medium]: size === 'medium',
    [css.large]: size === 'large',
  });

  return (
    <span className={classes} aria-hidden="true" role="img">
      ℹ️
    </span>
  );
};

export default IconInfo;

